import { useIsFormDisabled } from "@/flokit/compound/inputs/contexts/disabled-form-context";
import { InputDescription } from "@/flokit/compound/inputs/input-label/input-description";
import { InputLabel } from "@/flokit/compound/inputs/input-label/input-label";
import { normalizeLabelProp } from "@/flokit/compound/inputs/input-label/label-prop";
import { SelectOption } from "@/flokit/compound/inputs/select/base";
import { LabelledInputProps } from "@/flokit/compound/inputs/types";
import { useHtmlId } from "@/flokit/utils/html/use-html-id";
import { cn } from "@/flokit/utils/styling/cn";
import * as Checkbox from "@radix-ui/react-checkbox";
import { FiCheck } from "react-icons/fi";

export const CheckboxInput = (props: {
  value: SelectOption | null;
  label:
    | string
    | {
        type: "hidden";
        label: string;
      };
  onChange: (value: boolean) => void;
  isDisabled?: boolean;
}) => {
  const isDisabled = useIsFormDisabled() ?? props.isDisabled;

  return (
    <Checkbox.Root
      className="focus:ring-magenta group flex w-full flex-col rounded-md text-left outline-none focus:ring-2 focus:ring-offset-2"
      checked={Boolean(props.value)}
      disabled={isDisabled}
      onClick={(e) => {
        e.preventDefault();
        props.onChange(Boolean(!props.value));
      }}
      id={`checkbox-${props.value}`}
    >
      <div className="grid  grid-cols-[auto,1fr] gap-x-2 text-base">
        <div
          className={cn(
            "border-macbook mt-0.5 flex h-4 w-4 items-center justify-center rounded-md border",
            isDisabled ? "bg-offwhiteVariant" : null,
          )}
        >
          <Checkbox.Indicator className="bg-magenta block h-3 w-3 rounded">
            <FiCheck className="text-white" size={12} />
          </Checkbox.Indicator>
        </div>
        <label
          className={cn("text-base", isDisabled ? "opacity-70" : "")}
          htmlFor={`checkbox-${props.value}`}
        >
          {typeof props.label === "object" ? props.label.label : props.label}
        </label>
      </div>
    </Checkbox.Root>
  );
};

export const CheckboxGroupField = (
  props: {
    options: SelectOption[];
    value: SelectOption[];
    onChange: (value: SelectOption) => void;
    // TODO: Use the label prop stuff
    hideLabel?: boolean;
    description?: string;
  } & LabelledInputProps,
) => {
  const descriptionId = useHtmlId();
  const radioGroupId = useHtmlId();
  const labelMethod = normalizeLabelProp(props.label);
  return (
    <div className="w-full">
      {labelMethod.type === "default" || labelMethod.type === "hidden" ? (
        <InputLabel
          labelMethod={labelMethod}
          interactivity="interactive"
          isRequired={props.isRequired}
          isDisabled={props.isDisabled}
          tooltip={props.tooltip}
          idOfElementToBeLabeled={radioGroupId}
        />
      ) : null}
      {props.description ? (
        <div className="pt-0.5">
          <InputDescription id={descriptionId}>
            {props.description}
          </InputDescription>
        </div>
      ) : null}
      <div className="flex flex-col gap-y-2 pt-2">
        {props.options.map((option) => {
          return (
            <CheckboxInput
              key={option.value}
              value={
                props?.value?.find((v) => v.value === option.value) ?? null
              }
              label={option.label}
              onChange={(checked) => {
                props.onChange(option);
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

// className="border-macbook focus:ring-magenta mt-0.5 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full border shadow-sm outline-none focus:ring-1 focus:ring-offset-1"
